<template>
    <section class="m60s-assessment" :dir="$i18n.locale === 'ar-AR' ? 'rtl' : 'ltr'">
        <template v-if="kind === 'infrared'">
            <m60-s-infrared :report-data="data" />
        </template>
        <template v-else>
            <m60-s-vital-signs :report-data="data" />
        </template>
    </section>
</template>

<script>
import M60SInfrared from './M60SInfrared.vue'
import M60SVitalSigns from './M60SVitalSigns.vue'
export default {
    name: 'M60SAssessment',
    components: { M60SInfrared, M60SVitalSigns },
    props: { kind: { type: String, required: true }, dataString: { type: String, default: '' } },
    computed: { data() { try { return JSON.parse(this.dataString) || {} } catch (_) { return {} } } },
}
</script>

<style scoped>
.m60s-assessment { padding-bottom: 112px; color: #d9e3f5; overflow-wrap: anywhere; }
</style>
